import { store } from "../../store";

export const getOrgId = () => {
  const storeState = store?.getState();
  const orgDetails = storeState?.persistedDataReducer?.orgDetails?.organization;

  const orgDetailsFromCourse =
    storeState?.overviewReducer?.overViewDetails?.course?.orgDetails;
  return orgDetails?.id || orgDetails?.orgId || orgDetailsFromCourse?.id;
};

export const getUserCosmos = () => {
  const storeState = store?.getState();
  const userDetails =
    storeState?.overviewReducer?.userDetails?.responseData?.user;
  const orgDetails = storeState?.persistedDataReducer?.orgDetails?.organization;

  const orgDetailsFromCourse =
    storeState?.overviewReducer?.overViewDetails?.course?.orgDetails;

  return {
    name: userDetails?.name || undefined,
    org_code: orgDetails?.code || orgDetailsFromCourse?.code,
    org_id: orgDetails?.id || orgDetails?.orgId || orgDetailsFromCourse?.id,
    phone: userDetails?.mobile || undefined,
    source_user_id: userDetails?.id ? userDetails.id + "" : undefined, // BE expects source_user_id as STRING, converting to string
    user_type: 1,
    email: userDetails?.email || undefined,
    country_code: userDetails?.countryCode || undefined,
    is_userid_even: userDetails?.id ? userDetails.id % 2 === 0 : undefined,
  };
};
